import { Observable, Subject } from 'rxjs';

export class FloatingDialogRef<T = any, R = any> {

  componentInstance: T;

  // Inicjowane z konfiguracji przy otwarciu, ale komponent zawartości może to zmieniać w trakcie życia dialogu
  // (np. Escape zamyka tylko na pierwszym kroku kreatora, a nie nad niezapisanym formularzem).
  closeOnEscape = true;

  private readonly afterClosedSubject = new Subject<R | undefined>();
  private closeFn: (result?: R) => void;
  private closeGuard: (() => boolean) | null = null;

  // Pozwala komponentowi zawartości wstrzymać zamknięcie zainicjowane przez użytkownika (krzyżyk w nagłówku, Escape,
  // własny przycisk anuluj). Guard zwraca false, żeby zablokować zamknięcie - jeśli musi o coś zapytać asynchronicznie,
  // po potwierdzeniu wywołuje forceClose().
  setCloseGuard(guard: (() => boolean) | null): void {
    this.closeGuard = guard;
  }

  close(result?: R): void {
    if (this.closeGuard && !this.closeGuard()) return;
    this.forceClose(result);
  }

  // Zamknięcie pomijające guard - dla ścieżek, w których dialog nie może zostać osierocony (nawigacja, closeAll).
  forceClose(result?: R): void {
    this.closeFn?.(result);
  }

  afterClosed(): Observable<R | undefined> {
    return this.afterClosedSubject.asObservable();
  }

  // called only by FloatingDialogService
  _registerClose(fn: (result?: R) => void): void {
    this.closeFn = fn;
  }

  // called only by FloatingDialogService
  _emitClosed(result?: R): void {
    this.afterClosedSubject.next(result);
    this.afterClosedSubject.complete();
  }
}
